<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
    [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions"
    [responseArrayCallback]="responseArrayCallback" [cellDoubleClickedCallback]="cellDoubleClickedCallback"
    [rowClassRules]="rowClassRules" [updateStatusType]="updateStatusType">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" data-automation-id="organization-settings-add-new-key-file-button" class="secondary-button"
        (click)="addNewKeyFile()" *ngIf="hasEditPermissions">
        <i class="fa fa-plus"></i>New Key File ...
    </button>
</ng-template>